import PageNavBackLayoutCpt from '@/components/page/PageNavBackLayoutCpt';
import ListViewCpt from '@/components/list/ListViewCpt';
import cptCmn from '@/mixin/cpt-cmn';
import { rqtPostCustomeVisitInfo } from '@/services/cms/customer';
export default {
  mixins: [cptCmn],
  components: {
    PageNavBackLayoutCpt,
    ListViewCpt
  },
  data() {
    return {
      searchForm: {
        customerId: ''
      },
      listRequest: rqtPostCustomeVisitInfo,
      codeResItems: [{
        title: ' 拜访类型',
        dataIndex: 'visitType',
        dataType: 'select',
        dataRes: undefined,
        dataResItem: {
          key: 'code',
          title: 'codeName'
        },
        dataResCodeType: 'customerVisitType'
      }, {
        title: '拜访动作',
        dataIndex: 'visitAction',
        dataType: 'select',
        dataRes: undefined,
        dataResItem: {
          key: 'code',
          title: 'codeName'
        },
        dataResCodeType: 'customerVisitAction'
      }]
    };
  },
  created() {
    let customerId = this.$route.params && this.$route.params.customerId;
    if (customerId) {
      this.searchForm.customerId = customerId;
      this.initResCodeType(this.codeResItems);
    }
  }
};